import { cn } from "@/lib/utils";

/**
 * The number a record reads by, in v0.28's small box: the done colour once the
 * record has its place, and a dashed box with a dash while it waits for one,
 * as an element awaiting attention or a suggested addition does. Named for a
 * reader by `label`, since a dash says nothing aloud.
 */
export function NumberMark({
  number,
  label,
  testId,
}: {
  number: number | null;
  label: string;
  testId?: string;
}) {
  return (
    <span
      role="img"
      aria-label={label}
      data-testid={testId}
      className={cn(
        "mt-px grid h-5 min-w-5 flex-none place-items-center rounded-[6px] px-[5px] font-mono text-[10.5px] font-bold",
        number === null
          ? "border border-dashed border-border text-subtle-foreground"
          : "bg-success text-white",
      )}
    >
      {number ?? "–"}
    </span>
  );
}
